import { Ionicons } from '@expo/vector-icons';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';

import { Colors } from '@/constants/theme';
import { BorderRadius, Spacing } from '@/constants/spacing';
import { getBodyFont } from '@/constants/typography';

type SuggestionsLoadingBubbleProps = {
  isReady: boolean;
  onPress: () => void;
  bottomOffset: number;
};

/**
 * Floating bubble that appears while AI suggestions generate in the background.
 * Shows a spinner while loading, then "Ready" when complete.
 */
export function SuggestionsLoadingBubble({
  isReady,
  onPress,
  bottomOffset,
}: SuggestionsLoadingBubbleProps) {
  return (
    <Animated.View
      entering={FadeIn.duration(250)}
      exiting={FadeOut.duration(200)}
      style={[styles.container, { bottom: bottomOffset + 70 }]}
    >
      <TouchableOpacity
        style={[styles.bubble, isReady && styles.bubbleReady]}
        onPress={onPress}
        activeOpacity={0.8}
      >
        {isReady ? (
          <>
            <Ionicons name="sparkles" size={16} color="#FFFFFF" />
            <Text style={[styles.readyText, { fontFamily: getBodyFont() }]}>
              Ready
            </Text>
          </>
        ) : (
          <>
            <ActivityIndicator size="small" color="#FFD700" />
            <Text style={[styles.loadingText, { fontFamily: getBodyFont() }]}>
              Fim is thinking...
            </Text>
          </>
        )}
      </TouchableOpacity>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    alignSelf: 'center',
    zIndex: 99,
  },
  bubble: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Spacing.xs,
    backgroundColor: '#1C1C1E',
    paddingHorizontal: Spacing.md,
    paddingVertical: Spacing.sm,
    borderRadius: BorderRadius.full,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 5,
  },
  bubbleReady: {
    backgroundColor: Colors.light.tint,
  },
  loadingText: {
    fontSize: 13,
    color: 'rgba(255, 255, 255, 0.7)',
  },
  readyText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
  },
});
